export default {
    namespaced: true,
    state() {
        return {
            draggedItem: null,
        };
    },
    getters: {
        getDraggedItem: (state) => state.draggedItem,
    },
    mutations: {
        setDraggedItem(state, payload) {
            state.draggedItem = payload;
        },
    },
    actions: {
        updateDraggedItem({ commit }, payload) {
            commit('setDraggedItem', payload);
        },
    },
};
